import {
  GET_WAREHOUSE_REQUEST,
  GET_WAREHOUSE_SUCCESS,
  GET_WAREHOUSE_FAILURE,
  GET_YARDOCCUPANCY_REQUEST,
  GET_YARDOCCUPANCY_SUCCESS,
  GET_YARDOCCUPANCY_FAILURE,
  GET_INVENTORY_REQUEST,
  GET_INVENTORY_SUCCESS,
  GET_INVENTORY_FAILURE,
  GET_PICKUP_REQUEST,
  GET_PICKUP_SUCCESS,
  GET_PICKUP_FAILURE,
  GET_FINISHEDGOODSHP_REQUEST,
  GET_FINISHEDGOODSHP_SUCCESS,
  GET_FINISHEDGOODSHP_FAILURE,
  GET_PDI_REQUEST,
  GET_PDI_SUCCESS,
  GET_PDI_FAILURE,
  GET_REJECTION_REQUEST,
  GET_REJECTION_SUCCESS,
  GET_REJECTION_FAILURE,
  GET_NAVBAR_BOXES_REQUEST,
  GET_NAVBAR_BOXES_SUCCESS,
  GET_NAVBAR_BOXES_FAILURE,
  GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_REQUEST,
  GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_SUCCESS,
  GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_FAILURE,
  GET_GRN_REPORT_HOME_REQUEST,
  GET_GRN_REPORT_HOME_SUCCESS,
  GET_GRN_REPORT_HOME_FAILURE,
  GET_FG_REPORT_HOME_REQUEST,
  GET_FG_REPORT_HOME_SUCCESS,
  GET_FG_REPORT_HOME_FAILURE,
  GET_ITEM_STATUS_REPORT_HOME_REQUEST,
  GET_ITEM_STATUS_REPORT_HOME_SUCCESS,
  GET_ITEM_STATUS_REPORT_HOME_FAILURE,
  GET_INVENTORY_AGEING_REPORT_HOME_REQUEST,
  GET_INVENTORY_AGEING_REPORT_HOME_SUCCESS,
  GET_INVENTORY_AGEING_REPORT_HOME_FAILURE,
  GET_PICKLIST_AGEING_REPORT_HOME_REQUEST,
  GET_PICKLIST_AGEING_REPORT_HOME_SUCCESS,
  GET_PICKLIST_AGEING_REPORT_HOME_FAILURE,
  GET_TOP10_REPORT_HOME_REQUEST,
  GET_TOP10_REPORT_HOME_SUCCESS,
  GET_TOP10_REPORT_HOME_FAILURE,
  GET_EFFICIENCY_REPORT_HOME_REQUEST,
  GET_EFFICIENCY_REPORT_HOME_SUCCESS,
  GET_EFFICIENCY_REPORT_HOME_FAILURE,
  GET_VENDOR_COUNT_REQUEST,
  GET_VENDOR_COUNT_SUCCESS,
  GET_VENDOR_COUNT_FAILURE,
  GET_WAREHOUSE_ZONES_REQUEST,
  GET_WAREHOUSE_ZONES_SUCCESS,
  GET_WAREHOUSE_ZONES_FAILURE,
  GET_WAREHOUSE_CARD_DATA_SUCCESS,
  GET_WAREHOUSE_CARD_DATA_FAILURE,
  GET_WAREHOUSE_CARD_DATA_REQUEST,
  GET_EXPANDED_GRN_REPORT_HOME_REQUEST,
  GET_EXPANDED_GRN_REPORT_HOME_SUCCESS,
  GET_EXPANDED_GRN_REPORT_HOME_FAILURE,
  GET_EXPANDED_FG_REPORT_HOME_REQUEST,
  GET_EXPANDED_FG_REPORT_HOME_SUCCESS,
  GET_EXPANDED_FG_REPORT_HOME_FAILURE,
  GET_EXPANDED_INVENTORY_REPORT_HOME_REQUEST,
  GET_EXPANDED_INVENTORY_REPORT_HOME_SUCCESS,
  GET_EXPANDED_INVENTORY_REPORT_HOME_FAILURE,
  GET_EXPANDED_PICKLIST_REPORT_HOME_REQUEST,
  GET_EXPANDED_PICKLIST_REPORT_HOME_SUCCESS,
  GET_EXPANDED_PICKLIST_REPORT_HOME_FAILURE,
  GET_VENDOR_APPLICATION_REQUEST,
  GET_VENDOR_APPLICATION_SUCCESS,
  GET_VENDOR_APPLICATION_FAILURE,
  GET_VENDOR_MONTHLY_REQUEST,
  GET_VENDOR_MONTHLY_SUCCESS,
  GET_VENDOR_MONTHLY_FAILURE,
  GET_VENDOR_SUBSCRIPTION_COUNT_REQUEST,
  GET_VENDOR_SUBSCRIPTION_COUNT_SUCCESS,
  GET_VENDOR_SUBSCRIPTION_COUNT_FAILURE,
} from "./homeTypes";

const initialStateForWarehouseZoneReportHome = {
  loading: false,
  warehouses: [],
  error: "",
};

const getWarehouseZonesHomeReducer = (
  state = initialStateForWarehouseZoneReportHome,
  action
) => {
  switch (action.type) {
    case GET_WAREHOUSE_ZONES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_WAREHOUSE_ZONES_SUCCESS:
      return {
        loading: false,
        warehouses: action.payload,
        error: "",
      };
    case GET_WAREHOUSE_ZONES_FAILURE:
      return {
        loading: false,
        warehouses: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForWarehouseOccupancyDataHome = {
  loading: false,
  occupancy: [],
  error: "",
};

const getWarehouseOccupancyDataReducer = (
  state = initialStateForWarehouseOccupancyDataHome,
  action
) => {
  switch (action.type) {
    case GET_WAREHOUSE_CARD_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_WAREHOUSE_CARD_DATA_SUCCESS:
      return {
        loading: false,
        occupancy: action.payload,
        error: "",
      };
    case GET_WAREHOUSE_CARD_DATA_FAILURE:
      return {
        loading: false,
        occupancy: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForWarehouse = {
  loading: false,
  warehouses: [],
  error: "",
};

const getWarehouseReducer = (state = initialStateForWarehouse, action) => {
  switch (action.type) {
    case GET_WAREHOUSE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_WAREHOUSE_SUCCESS:
      return {
        loading: false,
        warehouses: action.payload,
        error: "",
      };
    case GET_WAREHOUSE_FAILURE:
      return {
        loading: false,
        warehouses: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForYardOccupancy = {
  loading: false,
  warehouses: [],
  error: "",
};

const getYardReducer = (state = initialStateForYardOccupancy, action) => {
  switch (action.type) {
    case GET_YARDOCCUPANCY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_YARDOCCUPANCY_SUCCESS:
      return {
        loading: false,
        warehouses: action.payload,
        error: "",
      };
    case GET_YARDOCCUPANCY_FAILURE:
      return {
        loading: false,
        warehouses: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForInventory = {
  loading: false,
  categories: [],
  error: "",
};

const getInventoryReducer = (state = initialStateForInventory, action) => {
  switch (action.type) {
    case GET_INVENTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_INVENTORY_SUCCESS:
      return {
        loading: false,
        categories: action.payload,
        error: "",
      };
    case GET_INVENTORY_FAILURE:
      return {
        loading: false,
        categories: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPickup = {
  loading: false,
  pickupList: [],
  error: "",
};

const getPickupReducer = (state = initialStateForPickup, action) => {
  switch (action.type) {
    case GET_PICKUP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PICKUP_SUCCESS:
      return {
        loading: false,
        pickupList: action.payload,
        error: "",
      };
    case GET_PICKUP_FAILURE:
      return {
        loading: false,
        pickupList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForFg = {
  loading: false,
  fg: [],
  error: "",
};

const getFgReducer = (state = initialStateForFg, action) => {
  switch (action.type) {
    case GET_FINISHEDGOODSHP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FINISHEDGOODSHP_SUCCESS:
      return {
        loading: false,
        fg: action.payload,
        error: "",
      };
    case GET_FINISHEDGOODSHP_FAILURE:
      return {
        loading: false,
        fg: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPdi = {
  loading: false,
  pdi: [],
  error: "",
};

const getPdiReducer = (state = initialStateForPdi, action) => {
  switch (action.type) {
    case GET_PDI_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PDI_SUCCESS:
      return {
        loading: false,
        pdi: action.payload,
        error: "",
      };
    case GET_PDI_FAILURE:
      return {
        loading: false,
        pdi: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForRejection = {
  loading: false,
  rejection: [],
  error: "",
};

const getRejectionReducer = (state = initialStateForRejection, action) => {
  switch (action.type) {
    case GET_REJECTION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REJECTION_SUCCESS:
      return {
        loading: false,
        rejection: action.payload,
        error: "",
      };
    case GET_REJECTION_FAILURE:
      return {
        loading: false,
        rejection: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForNavbarBoxes = {
  loading: false,
  navbarBoxes: [],
  error: "",
};

const getNavbarBoxesReducer = (state = initialStateForNavbarBoxes, action) => {
  switch (action.type) {
    case GET_NAVBAR_BOXES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_NAVBAR_BOXES_SUCCESS:
      return {
        loading: false,
        navbarBoxes: action.payload,
        error: "",
      };
    case GET_NAVBAR_BOXES_FAILURE:
      return {
        loading: false,
        navbarBoxes: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForWarehouseOccupancyReportHome = {
  loading: false,
  warehouses: [],
  error: "",
};

const getWarehouseOccupancyReportHomeReducer = (
  state = initialStateForWarehouseOccupancyReportHome,
  action
) => {
  switch (action.type) {
    case GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        warehouses: action.payload,
        error: "",
      };
    case GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_FAILURE:
      return {
        loading: false,
        warehouses: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForMonthly = {
  loading: false,
  warehouses: [],
  error: "",
};

const getVendorMonthlyReducer = (
  state = initialStateForMonthly,
  action
) => {
  switch (action.type) {
    case GET_VENDOR_MONTHLY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_VENDOR_MONTHLY_SUCCESS:
      return {
        loading: false,
        warehouses: action.payload,
        error: "",
      };
    case GET_VENDOR_MONTHLY_FAILURE:
      return {
        loading: false,
        warehouses: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForMonthlydEs = {
  loading: false,
  warehouses: [],
  error: "",
};

const getVendorSubscriptionCountReducer = (
  state = initialStateForMonthlydEs,
  action
) => {
  switch (action.type) {
    case GET_VENDOR_SUBSCRIPTION_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_VENDOR_SUBSCRIPTION_COUNT_SUCCESS:
      return {
        loading: false,
        warehouses: action.payload,
        error: "",
      };
    case GET_VENDOR_SUBSCRIPTION_COUNT_FAILURE:
      return {
        loading: false,
        warehouses: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForGrnReportHome = {
  loading: false,
  grn: [],
  error: "",
};

const getGrnReportHomeReducer = (
  state = initialStateForGrnReportHome,
  action
) => {
  switch (action.type) {
    case GET_GRN_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_GRN_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        grn: action.payload,
        error: "",
      };
    case GET_GRN_REPORT_HOME_FAILURE:
      return {
        loading: false,
        grn: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForFgReportHome = {
  loading: false,
  fg: [],
  error: "",
};

const getFgReportHomeReducer = (
  state = initialStateForFgReportHome,
  action
) => {
  switch (action.type) {
    case GET_FG_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FG_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        fg: action.payload,
        error: "",
      };
    case GET_FG_REPORT_HOME_FAILURE:
      return {
        loading: false,
        fg: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForItemStatusReportHome = {
  loading: false,
  itemStatus: [],
  error: "",
};

const getItemStatusReportHomeReducer = (
  state = initialStateForItemStatusReportHome,
  action
) => {
  switch (action.type) {
    case GET_ITEM_STATUS_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ITEM_STATUS_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        itemStatus: action.payload,
        error: "",
      };
    case GET_ITEM_STATUS_REPORT_HOME_FAILURE:
      return {
        loading: false,
        itemStatus: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForInventoryAgeingReportHome = {
  loading: false,
  inventoryAgeing: [],
  error: "",
};

const getInventoryAgeingReportHomeReducer = (
  state = initialStateForInventoryAgeingReportHome,
  action
) => {
  switch (action.type) {
    case GET_INVENTORY_AGEING_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_INVENTORY_AGEING_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        inventoryAgeing: action.payload,
        error: "",
      };
    case GET_INVENTORY_AGEING_REPORT_HOME_FAILURE:
      return {
        loading: false,
        inventoryAgeing: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPicklistAgeingReportHome = {
  loading: false,
  picklistAgeing: [],
  error: "",
};

const getPicklistAgeingReportHomeReducer = (
  state = initialStateForPicklistAgeingReportHome,
  action
) => {
  switch (action.type) {
    case GET_PICKLIST_AGEING_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PICKLIST_AGEING_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        picklistAgeing: action.payload,
        error: "",
      };
    case GET_PICKLIST_AGEING_REPORT_HOME_FAILURE:
      return {
        loading: false,
        picklistAgeing: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForTop10ReportHome = {
  loading: false,
  top10: [],
  error: "",
};

const getTop10ReportHomeReducer = (
  state = initialStateForTop10ReportHome,
  action
) => {
  switch (action.type) {
    case GET_TOP10_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TOP10_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        top10: action.payload,
        error: "",
      };
    case GET_TOP10_REPORT_HOME_FAILURE:
      return {
        loading: false,
        top10: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForTop10ReportHomD = {
  loading: false,
  top10: [],
  error: "",
};

const getVendorApplicationReducer = (
  state = initialStateForTop10ReportHomD,
  action
) => {
  switch (action.type) {
    case GET_VENDOR_APPLICATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_VENDOR_APPLICATION_SUCCESS:
      return {
        loading: false,
        top10: action.payload,
        error: "",
      };
    case GET_VENDOR_APPLICATION_FAILURE:
      return {
        loading: false,
        top10: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForWarehouseEfficiencyReportHome = {
  loading: false,
  warehouseEfficiency: [],
  error: "",
};

const getWarehouseEfficiencyReportHomeReducer = (
  state = initialStateForWarehouseEfficiencyReportHome,
  action
) => {
  switch (action.type) {
    case GET_EFFICIENCY_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_EFFICIENCY_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        warehouseEfficiency: action.payload,
        error: "",
      };
    case GET_EFFICIENCY_REPORT_HOME_FAILURE:
      return {
        loading: false,
        warehouseEfficiency: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForVendorStatusCounts = {
  loading: false,
  vendorStatusCounts: [],
  error: "",
};

const getVendorStatusCountsReducer = (
  state = initialStateForVendorStatusCounts,
  action
) => {
  switch (action.type) {
    case GET_VENDOR_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_VENDOR_COUNT_SUCCESS:
      return {
        loading: false,
        vendorStatusCounts: action.payload,
        error: "",
      };
    case GET_VENDOR_COUNT_FAILURE:
      return {
        loading: false,
        vendorStatusCounts: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForExpandedGrnReportHome = {
  loading: false,
  expandedGrn: [],
  error: "",
};

const getExpandedGrnReportHomeReducer = (
  state = initialStateForExpandedGrnReportHome,
  action
) => {
  switch (action.type) {
    case GET_EXPANDED_GRN_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_EXPANDED_GRN_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        expandedGrn: action.payload,
        error: "",
      };
    case GET_EXPANDED_GRN_REPORT_HOME_FAILURE:
      return {
        loading: false,
        expandedGrn: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForExpandedFgReportHome = {
  loading: false,
  expandedFg: [],
  error: "",
};

const getExpandedFgReportHomeReducer = (
  state = initialStateForExpandedFgReportHome,
  action
) => {
  switch (action.type) {
    case GET_EXPANDED_FG_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_EXPANDED_FG_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        expandedFg: action.payload,
        error: "",
      };
    case GET_EXPANDED_FG_REPORT_HOME_FAILURE:
      return {
        loading: false,
        expandedFg: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForExpandedInventoryReportHome = {
  loading: false,
  expandedInventory: [],
  error: "",
};

const getExpandedInventoryReportHomeReducer = (
  state = initialStateForExpandedInventoryReportHome,
  action
) => {
  switch (action.type) {
    case GET_EXPANDED_INVENTORY_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_EXPANDED_INVENTORY_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        expandedInventory: action.payload,
        error: "",
      };
    case GET_EXPANDED_INVENTORY_REPORT_HOME_FAILURE:
      return {
        loading: false,
        expandedInventory: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForExpandedPicklistReportHome = {
  loading: false,
  expandedPicklist: [],
  error: "",
};

const getExpandedPicklistReportHomeReducer = (
  state = initialStateForExpandedPicklistReportHome,
  action
) => {
  switch (action.type) {
    case GET_EXPANDED_PICKLIST_REPORT_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_EXPANDED_PICKLIST_REPORT_HOME_SUCCESS:
      return {
        loading: false,
        expandedPicklist: action.payload,
        error: "",
      };
    case GET_EXPANDED_PICKLIST_REPORT_HOME_FAILURE:
      return {
        loading: false,
        expandedPicklist: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getWarehouseReducer,
  getYardReducer,
  getInventoryReducer,
  getPickupReducer,
  getFgReducer,
  getPdiReducer,
  getRejectionReducer,
  getNavbarBoxesReducer,
  getWarehouseOccupancyReportHomeReducer,
  getGrnReportHomeReducer,
  getFgReportHomeReducer,
  getItemStatusReportHomeReducer,
  getInventoryAgeingReportHomeReducer,
  getPicklistAgeingReportHomeReducer,
  getTop10ReportHomeReducer,
  getWarehouseEfficiencyReportHomeReducer,
  getVendorStatusCountsReducer,
  getWarehouseOccupancyDataReducer,
  getWarehouseZonesHomeReducer,
  getExpandedGrnReportHomeReducer,
  getExpandedFgReportHomeReducer,
  getExpandedInventoryReportHomeReducer,
  getExpandedPicklistReportHomeReducer,
  getVendorApplicationReducer,
  getVendorMonthlyReducer,
  getVendorSubscriptionCountReducer
};
